'use client';

import {FlowStepHeading, FlowTextarea, FlowValidationError} from './flow_form';

const MIN_CHARS = 200;
const STEP_QUESTION =
  'Take us inside the interview. What happened when you actually sat down? How many rounds, what surprised you, where did you feel confident and where did you start sweating? We want the real version, not the LinkedIn version.';

type Props = {
  step: number;
  totalSteps: number;
  value: string;
  onChange: (v: string) => void;
  validationError: string | null;
  validating: boolean;
};

export function FlowStepExperience({
  step,
  totalSteps,
  value,
  onChange,
  validationError,
  validating,
}: Props) {
  const charCount = value.trim().length;

  return (
    <div className='flex flex-col gap-4'>
      <FlowStepHeading step={step} totalSteps={totalSteps}>
        {STEP_QUESTION}
      </FlowStepHeading>
      <div>
        <FlowTextarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder='Walk us through it from the beginning...'
          rows={7}
          disabled={validating}
        />
        <p
          className={`text-xs mt-1.5 text-right ${charCount >= MIN_CHARS ? 'text-iq-grey-medium' : 'text-iq-red'}`}>
          {charCount} / {MIN_CHARS} characters {charCount < MIN_CHARS ? 'minimum' : ''}
        </p>
      </div>
      {validationError && <FlowValidationError message={validationError} />}
    </div>
  );
}
